import RichTextEditorParser from './RichTextEditorParser.vue'

export default RichTextEditorParser
